<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Сводный отчёт (Соц)</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end flex-wrap gap-3">
        <div class="me-3">
          <label class="form-label">Год</label>
          <select v-model="year" class="form-select">
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
        </div>

        <!--
        <b-button
          variant="success"
          :disabled="isLoading"
          @click="downloadPayout"
        >
          Сформировать «Отчёт по выплаченным суммам»
        </b-button>
        -->

        <b-button
            variant="success"
            :disabled="isLoading"
            @click="downloadSocial"
        >
          Сформировать «Соц категории»
        </b-button>
      </div>
    </div>
    <vue-loading :active.sync="isLoading" :is-full-page="true" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import summarySocialReportService from "@/services/summarySocialReportService";
import VueLoading from "vue-loading-overlay";

export default defineComponent({
  components: { VueLoading },
  data() {
    return {
      year: new Date().getFullYear(),
      years: Array.from({ length: 7 }, (_, i) => 2024 + i),
      isLoading: false,
    };
  },
  methods: {
    getFilenameFromDisposition(disposition: string | undefined, fallback: string): string {
      if (!disposition) return fallback;
      const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
      return match ? decodeURIComponent(match[1]) : fallback;
    },
    /*  downloadPayout() {
          // код оставлен для дальнейшего использования
       }, */
    async downloadSocial() {
      this.isLoading = true;
      try {
        const res = await summarySocialReportService.social(this.year);
        const blob = new Blob([res.data], { type: res.headers["content-type"] });
        const cd = res.headers["content-disposition"];
        const fallback = `social-categories-${this.year}.xlsx`;
        const filename = this.getFilenameFromDisposition(cd, fallback);
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
</script>

<style scoped>
.row {
  padding-top: 5px;
}
.add-item-block .btn + .btn {
  margin-left: 10px;
}
</style>
